import { Navigation } from "core/helpers/navigation";
import { authFallBack, routeList } from "routing/routeList";

export function App() {
  return <Navigation routeList={routeList} authFallBack={authFallBack} />;
}
